var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNewExcel = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 800,
  height: 800,
  viewBox: "0 0 32 32"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "newExcel_svg__a",
  x1: 4.494,
  x2: 13.832,
  y1: -2092.086,
  y2: -2075.914,
  gradientTransform: "translate(0 2100)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#18884f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#117e43"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0b6631"
})))), /*#__PURE__*/React.createElement("path", {
  d: "M19.581 15.35 8.512 13.4v14.409A1.19 1.19 0 0 0 9.705 29h19.1A1.19 1.19 0 0 0 30 27.809V22.5Z",
  style: {
    fill: "#185c37"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.581 3H9.705a1.19 1.19 0 0 0-1.193 1.191V9.5L19.581 16l5.861 1.95L30 16V9.5Z",
  style: {
    fill: "#21a366"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.512 9.5h11.069V16H8.512Z",
  style: {
    fill: "#107c41"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.434 8.2H8.512v16.25h7.922a1.2 1.2 0 0 0 1.194-1.191V9.391A1.2 1.2 0 0 0 16.434 8.2",
  style: {
    opacity: 0.10000000149011612,
    isolation: "isolate"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.783 8.85H8.512V25.1h7.271a1.2 1.2 0 0 0 1.194-1.191V10.041a1.2 1.2 0 0 0-1.194-1.191",
  style: {
    opacity: 0.20000000298023224,
    isolation: "isolate"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.783 8.85H8.512V23.8h7.271a1.2 1.2 0 0 0 1.194-1.191V10.041a1.2 1.2 0 0 0-1.194-1.191",
  style: {
    opacity: 0.20000000298023224,
    isolation: "isolate"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.132 8.85h-6.62V23.8h6.62a1.2 1.2 0 0 0 1.194-1.191V10.041a1.2 1.2 0 0 0-1.194-1.191",
  style: {
    opacity: 0.20000000298023224,
    isolation: "isolate"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.194 8.85h11.938a1.193 1.193 0 0 1 1.194 1.191v11.918a1.193 1.193 0 0 1-1.194 1.191H3.194A1.19 1.19 0 0 1 2 21.959V10.041A1.19 1.19 0 0 1 3.194 8.85",
  style: {
    fill: "url(#newExcel_svg__a)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m5.7 19.873 2.511-3.884-2.3-3.862h1.847L9.013 14.6c.116.234.2.408.238.524h.017q.123-.281.26-.546l1.342-2.447h1.7l-2.359 3.84 2.419 3.905h-1.809l-1.45-2.711A2.4 2.4 0 0 1 9.2 16.8h-.024a1.7 1.7 0 0 1-.168.351l-1.493 2.722Z",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.806 3h-9.225v6.5H30V4.191A1.19 1.19 0 0 0 28.806 3",
  style: {
    fill: "#33c481"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.581 16H30v6.5H19.581Z",
  style: {
    fill: "#107c41"
  }
}));
export { SvgNewExcel as ReactComponent };
export default __webpack_public_path__ + "static/media/newExcel.ff7ce002.svg";